import React from 'react';
import "./style.css";
interface LabelProps {
    title: string;
    htmlFor: string;
  }
  
  export const Label: React.FC<LabelProps> = ({ title, htmlFor }) => {
    return (
      <label className='label-dsg' htmlFor={htmlFor}>{title}</label>
    );
  }
  